import { NgModule } from '@angular/core';
import { PortfolioComponent } from './portfolio.component';
import { RouterModule } from '@angular/router';

import { SharedModule } from "app/modules/shared/shared.module"; // using minusSignToParens only
import { NWMControls } from 'app/components/Controls/NWMControls.module';

@NgModule({
    imports: [
        RouterModule,
        SharedModule.forRoot(),
        NWMControls,
        PortfolioComponent,
    ],
    providers: []
})
export class PortfolioModule { }
